import Vue from 'vue';

// Contexto de operación (sucursal y caja elegidas).
//
// Antes vivía en cookies con domain=.legorsoft.click, que es compartido por
// todos los subdominios: entrar a una empresa y después a otra hacía que la
// segunda heredara la sucursal de la primera. localStorage está aislado por
// origen, así que cada subdominio/empresa tiene el suyo.
//
// Como la API vive en api.legorsoft.click (otro origen), el valor no viaja
// solo: se manda en headers desde el interceptor de axios.

export const SUCURSAL_KEY = '_sl_id';
export const CAJA_KEY = '_cj_id';

export function getSucursalUuid() {
    return localStorage.getItem(SUCURSAL_KEY) || null;
}

export function setSucursalUuid(uuid) {
    localStorage.setItem(SUCURSAL_KEY, uuid);
}

export function removeSucursalUuid() {
    localStorage.removeItem(SUCURSAL_KEY);
}

export function getCajaId() {
    return localStorage.getItem(CAJA_KEY) || null;
}

export function setCajaId(id) {
    localStorage.setItem(CAJA_KEY, id);
}

export function removeCajaId() {
    localStorage.removeItem(CAJA_KEY);
}

// Limpia las cookies viejas del dominio compartido. Sin esto siguen viajando
// al backend y pisan el contexto de cualquier empresa que el usuario abra.
export function limpiarCookiesLegacy() {
    const domain = process.env.VUE_APP_SUBDOMAIN_URL;
    [SUCURSAL_KEY, CAJA_KEY].forEach((key) => {
        if (Vue.$cookies.get(key)) {
            Vue.$cookies.remove(key, '/', domain);
        }
        Vue.$cookies.remove(key, '/');
    });
}
